import './App.css';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {
  Collection,
  Draft,
  Editor,
  Landing,
  ProtectedRoute,
  Replay,
  SharedLayout,
  Stats,
} from './pages';
import { useEthers } from '@usedapp/core';
import { useDispatch } from 'react-redux';
import { connect, disconnect } from './features/user/userSlice';
import { useMemori } from './hooks';

function App() {
  const { account, chainId } = useEthers();
  const [address] = useMemori();
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.ethereum) {
      dispatch(connect({ account, chainId, contract: address }));

      window.ethereum.on('accountsChanged', function (accounts) {
        if (accounts.length > 0) {
          dispatch(connect({ account: accounts[0], chainId }));
        } else {
          dispatch(disconnect());
        }
      });
    }
  }, [account, address, chainId, dispatch]);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='/'
          element={
            <ProtectedRoute>
              <SharedLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Stats />} />
          <Route path='/nft' element={<Collection />} />
          <Route path='/draft' element={<Draft />} />
          <Route path='/editor' element={<Editor />} />
        </Route>
        <Route path='/replay' element={<Replay />} />
        <Route path='/landing' element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
